var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #00095b;\n      }\n\n      .cls-1 {\n        clip-rule: evenodd;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-1",
    d: "M1363.914,825.755a6.467,6.467,0,0,1-1.33,3.956l-.913-.792a5.227,5.227,0,0,0,0-6.327l.913-.794A6.474,6.474,0,0,1,1363.914,825.755Zm.49-5.54-.913.794a7.839,7.839,0,0,1,0,9.492l.913.794a9.168,9.168,0,0,0,0-11.08Zm1.822-1.584-.914.794a10.465,10.465,0,0,1,0,12.658l.914.8a11.8,11.8,0,0,0,0-14.247Zm-16.432,12.124a11.222,11.222,0,0,1,0-10h3.53l7.059-5v20l-7.059-5Zm3.53-3.751v-5h-2.875a11.052,11.052,0,0,0,0,7.5h3.232l5.526,3.915v-15.33l-4.707,3.334v4.332A1.215,1.215,0,0,1,1353.324,827Z",
    transform: "translate(-1348.618 -815.755)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    className: "cls-2",
    width: 135.653,
    height: 96.957
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(-1348.618 -815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    className: "cls-3",
    transform: "translate(1348.618 815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(-38.696 -38.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    className: "cls-2",
    width: 20.871,
    height: 20.87,
    transform: "translate(38.26 37.826)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.0a3d836c5cc621ba45d02123bfad1824.svg";
export { ForwardRef as ReactComponent };